import makeApiCall from "../master/axiosIndex";
import { LoginCredentials } from "../types/auth/authTypes";
const authService = {
  login: (credentials: LoginCredentials): Promise<any> => {
    return makeApiCall({
      url: "/auth/login",
      method: "post",
      data: credentials,
    });
  },
  setPassword: (credentials: any, accessToken: any): Promise<any> => {
    return makeApiCall({
      url: "/users/editPassword",
      method: "put",
      data: credentials,
    });
  },
  reSetPassword: (data: any): Promise<any> => {
    return makeApiCall({
      url: "/users/sendResetEmailToRegisteredUser",
      method: "post",
      data,
    });
  },
  logout: (): Promise<any> => {
    return makeApiCall({
      url: "/auth/logout",
      method: "post",
    });
  },
  refreshToken: (): Promise<any> => {
    return makeApiCall({
      url: "/auth/refresh",
      method: "post",
    });
  },
  // Remote kill switch: ends every OTHER active session (web + mobile) while
  // keeping this one alive. Response: { status, revoked }.
  // "Active Sessions": list the caller's live sessions (safe fields only).
  listSessions: (): Promise<any> => {
    return makeApiCall({
      url: "/auth/sessions",
      method: "get",
    });
  },
  // Revoke ONE of the caller's sessions ("that device only").
  revokeSession: (sessionId: string): Promise<any> => {
    return makeApiCall({
      url: "/auth/sessions/revoke",
      method: "post",
      data: { sessionId },
    });
  },
  revokeOtherSessions: (): Promise<any> => {
    return makeApiCall({
      url: "/auth/sessions/revoke-all",
      method: "post",
      data: { keepCurrent: true },
    });
  },
  createSessionHandoff: (): Promise<any> => {
    return makeApiCall({
      url: "/auth/session/handoff",
      method: "post",
    });
  },
  createLoginActivity: (data: any): Promise<any> => {
    return makeApiCall({
      url: "/misc/createLoginActivity",
      method: "post",
      data,
    });
  },
  codeExchangeForAccessToken: (data: any): Promise<any> => {
    return makeApiCall({
      url: "/auth/sso/login",
      method: "post",
      data,
    });
  },
};

export default authService;
